import { ExclamationCircleIcon } from '@heroicons/react/16/solid';
import React, { useEffect, useRef } from "react";
import DatePicker from "react-multi-date-picker";
import { useSelector } from "react-redux";
import { classNames } from "../../helpers";
import { loadingState } from "../../redux/reducers/loadingReducer";
import TimePicker from 'react-multi-date-picker/plugins/time_picker';

export default function TwTimePicker(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "" } = props
  const datepickerRef = useRef();
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.containerClassName
  delete inputProps.className
  delete inputProps.inputClass
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }
  if (inputProps.disabled && inputProps.disabled !== undefined) {
    inputClass += " !bg-gray-200"
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (datepickerRef.current && !datepickerRef.current.contains(event.target) && datepickerRef?.current?.isOpen) {
        datepickerRef?.current.closeCalendar();
      }
    }

    return () => document.addEventListener("mousedown", handleClickOutside);
  }, [datepickerRef?.current?.isOpen]);


  function handleClickDatepickerIcon() {
    const datepickerElement = datepickerRef.current;
    // console.log("datepickerElement = ", datepickerElement);
    // datepickerElement.setFocus(true);
    if (datepickerElement.isOpen) {
      datepickerElement.closeCalendar();
    } else {
      datepickerElement.openCalendar();
    }
  }

  return (
    <div className={classNames("w-full sm:w-full sm:max-w-sm md:max-w-lg", props.outerContainerClassName)}>
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className="mt-2">
        <div className={classNames("flex items-center rounded-xl bg-input-bz px-4 md:px-5 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 ", inputClass)}>
          {leftIcon && (
            <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6 cursor-pointer" onClick={() => handleClickDatepickerIcon()}>{leftIcon}</div>
          )}
          <DatePicker
            // format="hh:mm:ss A"
            format="hh:mm A"
            {...inputProps}
            aria-invalid={props.error ? "true" : ""}
            aria-describedby={props.error ? "email-error" : ""}
            containerClassName={classNames("w-full", props.containerClassName)}
            className={classNames("w-full bookzy-calendar bookzy-border bookzy-range-calendar", props.className)}
            inputClass={classNames("bg-transparent w-full min-w-0 grow py-3 pl-3 md:py-5 md:pl-5 text-lg text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6 disabled:bg-gray-200",
              props.error ? "pr-3" : "pr-0",
              props.inputClass
            )}
            disableDayPicker
            ref={datepickerRef}
            plugins={[
              <TimePicker hideSeconds position="bottom" hStep={1} mStep={1} sStep={5} />,
            ]}
          />
          {rightIcon && (
            <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6 cursor-pointer" onClick={() => handleClickDatepickerIcon()}>{rightIcon}</div>
          )}
          {props.error && (<ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />)}
        </div>
      </div>
      {props?.helperText && (<p className="mt-2 text-sm text-gray-400">
        {props.helperText}
      </p>)}
      {props.error && (<p id="email-error" className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
